import React from 'react';
import styled from '@emotion/styled';
import * as bp from '@ecologi/react-components/src/theme/ecologi-breakpoints';

const Outer = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.forestDark};
  padding: 90px 15px;
`;

const Inner = styled.div`
  display: flex;
  width: 100%;
  text-align: center;

  color: ${(props) => props.theme.colors.mistLight};
  justify-items: center;
  flex-direction: row;
  max-width: 1180px;
  margin: 0 auto;

  @media ${bp.wideDesktopDown} {
    max-width: 980px;
  }
  @media only screen and (max-width: 900px) {
    flex-direction: column;
  }
`;

const BigQuotes = styled.svg`
  position: absolute;
  left: -30px;
  top: -25px;

  @media ${bp.wideDesktopDown} {
    left: -18px;
    top: -20px;
    height: 35px;
    width: 30px;
  }
`;

const SmallQuotes = styled.div`
  color: ${(props) => props.theme.colors.fern};
  display: inline-block;
  font-size: 47px;
  line-height: 47px;
  @media ${bp.wideDesktopDown} {
    font-size: 30px;
    line-height: 30px;
  }
`;

const Left = styled.div`
  display: flex;
  flex: 1;
`;

const VideoContainer = styled.div`
  width: 100%;
  max-width: 100%;

  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const Right = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-end;
  align-content: flex-start;
  padding-top: 40px;

  @media ${bp.wideDesktopDown} {
    padding-top: 10px;
  }

  @media only screen and (max-width: 900px) {
    padding-top: 40px;
  }
`;

const Title = styled.div`
  background: ${(props) => props.theme.colors.mistLight};
  color: ${(props) => props.theme.colors.charcoal};
  display: block;
  font-size: 40px;
  font-weight: bold;
  line-height: 40px;
  outline: none;
  padding: 16px 20px;
  display: inline-block;
  margin-bottom: 10px;
  position: relative;

  @media ${bp.wideDesktopDown} {
    font-size: 30px;
    line-height: 30px;
  }
  @media ${bp.mobileDown} {
    font-size: 25px;
    line-height: 25px;
  }
`;

const NameText = styled.div`
  font-size: 35px;
  font-weight: 600;
  margin-top: 24px;

  @media ${bp.wideDesktopDown} {
    font-size: 30px;
    margin-top: 20px;
  }
`;

const TitleText = styled.div`
  font-size: 22px;
  font-weight: 600;
  margin-top: 24px;

  @media ${bp.wideDesktopDown} {
    font-size: 18px;
    margin-top: 15px;
  }
`;

  

export const Krystal = () => {
  return (
    <Outer>
      <Inner>
        <Left>
          <VideoContainer>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/LYbiG8mkjOs"
              title="YouTube video player"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </VideoContainer>
        </Left>
        <Right>
          <Title>
            <BigQuotes
              width="53"
              height="53"
              viewBox="0 0 34 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.1557 0C26.1952 2.41237 23.1451 6.21649 20.0053 11.4124C16.8654 16.6082 15.3404 21.8041 15.3404 27H25.5673C25.5673 21.0619 26.3747 16.5155 28.5277 12.0619C29.6042 9.83505 30.4116 8.25773 30.9499 7.42268C31.4881 6.58763 32.4749 5.01031 34 2.87629L29.1557 0ZM13.8153 0C10.8549 2.41237 7.80475 6.21649 4.66491 11.4124C1.52507 16.6082 0 21.8041 0 27H10.2269C10.2269 21.0619 11.0343 16.5155 13.1873 12.0619C14.2639 9.83505 15.0712 8.25773 15.6095 7.42268C16.1478 6.58763 17.1346 5.01031 18.6596 2.87629L13.8153 0Z"
                fill="#0A9E76"
              />
            </BigQuotes>{' '}
            A business of any size can
          </Title>
          <Title>
            start doing good today<SmallQuotes>”</SmallQuotes>
          </Title>
          <NameText>Simon Blackler</NameText>
          <TitleText>CEO, Krystal</TitleText>
        </Right>
      </Inner>
    </Outer>
  );
};
